import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";
import { toast } from "react-toastify";
import { POLICY_API, USER_MANAGEMENT_API, USER_MANAGEMENT_CREATE_API } from "../../constants/constants";
import { fetchCreateUserFailure, fetchCreateUserSucess } from "./reducer";
import { uploadDocument } from "../../customer/documentupload/thunk";

export const createUser = (jsonObj, setLoading, onComplete, file) => (dispatch) => {
    setLoading(true)
    const roleName = localStorage.getItem("roleName")
    
    determineBaseUrlAndPerformApiCall(`${USER_MANAGEMENT_CREATE_API}`, 'POST', jsonObj)
        .then((response) => {
            setLoading(false)
            
            if (!response.error) {
                dispatch(fetchCreateUserSucess(response))
                
                const formData = new FormData()
                formData.append("ID", response?.data?.userDetails?.userId)
                
                if(roleName === "systemUser"){
                    formData.append("userType","operator")
                }
                
                formData.append("file", file);
                formData.append("documentName", "logo");
                formData.append("documentType", "logo");
                formData.append('uploadedBy', response?.data?.userDetails?.userName)
                
                if (file) {
                    // Enhanced uploadDocument call with success callback
                    dispatch(uploadDocument(
                        formData, 
                        setLoading, 
                        response?.data?.userDetails?.userId, 
                        "User", 
                        (uploadSuccess) => {
                            if (uploadSuccess) {
                                dispatch(setSuccessMessage(true));
                                // Call the success callback to close modal
                                if (onComplete) {
                                    onComplete(true);
                                }
                            } else {
                                // Upload failed, don't close modal
                                if (onComplete) {
                                    onComplete(false);
                                }
                            }
                        }
                    ))
                } else {
                    // No file to upload, operation successful
                    dispatch(setSuccessMessage(true));
                    // Call the success callback to close modal
                    if (onComplete) {
                        onComplete(true);
                    }
                }
            } else {
                // API call failed
                dispatch(fetchCreateUserFailure(response.error.message))
                toast.error(`${response.error.message}`)
                // Call the callback with failure status
                if (onComplete) {
                    onComplete(false);
                }
            }
        })
        .catch((errorResp) => {
            setLoading(false)
            console.error("Create user error:", errorResp)
            // Call the callback with failure status
            if (onComplete) {
                onComplete(false);
            }
        })
}